"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestTimesResponseDtoTierEnum = void 0;
exports.instanceOfDigestTimesResponseDto = instanceOfDigestTimesResponseDto;
exports.DigestTimesResponseDtoFromJSON = DigestTimesResponseDtoFromJSON;
exports.DigestTimesResponseDtoFromJSONTyped = DigestTimesResponseDtoFromJSONTyped;
exports.DigestTimesResponseDtoToJSON = DigestTimesResponseDtoToJSON;
exports.DigestTimesResponseDtoToJSONTyped = DigestTimesResponseDtoToJSONTyped;
var SelectedDigestTimesDto_1 = require("./SelectedDigestTimesDto");
var DigestSlotGroupDto_1 = require("./DigestSlotGroupDto");
/**
 * @export
 */
exports.DigestTimesResponseDtoTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the DigestTimesResponseDto interface.
 */
function instanceOfDigestTimesResponseDto(value) {
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    if (!('selected' in value) || value['selected'] === undefined)
        return false;
    if (!('groups' in value) || value['groups'] === undefined)
        return false;
    return true;
}
function DigestTimesResponseDtoFromJSON(json) {
    return DigestTimesResponseDtoFromJSONTyped(json, false);
}
function DigestTimesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tier': json['tier'],
        'selected': (0, SelectedDigestTimesDto_1.SelectedDigestTimesDtoFromJSON)(json['selected']),
        'groups': (json['groups'].map(DigestSlotGroupDto_1.DigestSlotGroupDtoFromJSON)),
    };
}
function DigestTimesResponseDtoToJSON(json) {
    return DigestTimesResponseDtoToJSONTyped(json, false);
}
function DigestTimesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'tier': value['tier'],
        'selected': (0, SelectedDigestTimesDto_1.SelectedDigestTimesDtoToJSON)(value['selected']),
        'groups': (value['groups'].map(DigestSlotGroupDto_1.DigestSlotGroupDtoToJSON)),
    };
}
